.resizer {
  background-color: var(--color-border);
  z-index: 100;
  transition: background-color 0.15s ease;
  position: relative;
}

.resizer:hover, .resizing {
  background-color: var(--color-primary);
}

.horizontal {
  width: 4px;
  cursor: col-resize;
  /* extend hit area slightly */
  margin-left: -2px;
  margin-right: -2px;
  padding: 0 2px;
  background-clip: content-box;
}

.vertical {
  height: 4px;
  cursor: row-resize;
  /* extend hit area slightly */
  margin-top: -2px;
  margin-bottom: -2px;
  padding: 2px 0;
  background-clip: content-box;
}
